import {BASE_PATH_PORTAL, PORTAL_URL, TIMEOUT_TIME} from 'constants/general'
import axios from 'axios'


// Funcion Post Recovery Password
export  async function postRecoveryPass({email} = {}){
   
    //const apiURL = `${BASE_PATH_PORTAL}/recuperar-contrasena/`
    const apiURL = `${PORTAL_URL}/recuperar-contrasena/`
    const data = `accion=iniciar_recuperar&email=${encodeURIComponent(email)}`

    const config = {
        method: 'post',
        url: apiURL,
        timeout: TIMEOUT_TIME,
        withCredentials: false,
        data: data,
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    };

    return await axios(config)
    .then(res => {
        const {
            headers, 
            status, 
            data
        } = res
        return {
            'headers': headers,
            'statusCode': status,
            'data': data,
            'error': ''
        }
    })
    .catch(error =>{
        //console.log(error)
        return {
            'headers': '',
            'statusCode': error.request.status,
            'data': error.request.response,
            'error': error.response.data.msg
        }
    })
}
